import { render, staticRenderFns } from "./Client-account.vue?vue&type=template&id=6f1bae8a&scoped=true"
import script from "./Client-account.vue?vue&type=script&lang=js"
export * from "./Client-account.vue?vue&type=script&lang=js"
import style0 from "./Client-account.vue?vue&type=style&index=0&id=6f1bae8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1bae8a",
  null
  
)

export default component.exports